export default __webpack_public_path__ + "static/media/phillip_warren.7a7a319d.jpg";